import * as React from 'react';
import { Table } from 'antd';
import UserContext from '../../../../../contexts/UserContext';
import { getUserScores, IUserScore } from '../api';
import { AimScoresBox } from './AimScores.css';
import { displayDate } from '../../../../../games/functions';

const tColumns = [
    {
        title: 'Score',
        dataIndex: 'level',
    },
    {
        title: 'Date',
        dataIndex: 'date',
        render: (date: string) => displayDate(date),
    }
];

const AimScores = (props: { gameId: number }) => {
    const {gameId} = props;
    const {useState, useContext, useEffect} = React;
    const {user} = useContext(UserContext);
    const [userScores, setUserScores] = useState<IUserScore[]>([]);

    useEffect(() => {
        (async function() {
            const scores = await getUserScores(user.id, gameId);
            setUserScores(scores);
        })();
    }, []);

    return (
        <AimScoresBox>
            <Table columns={tColumns} dataSource={userScores} pagination={false} />
        </AimScoresBox>
    );
};

export default AimScores;